import * as packageJson from '../package.json'
import MessageChannelEmulator from './message_channel_emulator'
import MessageChannelQWebChannel from './message_channel_qwebchannel'
import AudioService from './services/audio'
import BarcodeService from './services/barcode'
import CameraService from './services/camera'
import CustomService from './services/custom'
import DialogService from './services/dialog'
import DispenserService from './services/dispenser'
import DocumentScannerService from './services/document_scanner'
import DriveService from './services/drive'
import EnvironmentService from './services/environment'
import FaceRecognizeService from './services/face_recognize'
import FilesystemService from './services/filesystem'
import FingerprintScannerService from './services/fingerprint'
import InteractionService from './services/interaction'
import KeyboardService from './services/keyboard'
import LogService from './services/log'
import MailService from './services/mail'
import OperatorService from './services/operator'
import PassportScannerService from './services/passport_scanner'
import PaymentTerminalService from './services/payment_terminal'
import PrinterService from './services/printer'
import PromobotPrintPhotoService from './services/printer_photo'
import PushService from './services/push'
import RfidSecondaryService from './services/rfid_secondary'
import RfidService from './services/rfid'
import ScriptsService from './services/scripts'
import SettingsService from './services/settings'
import SipService from './services/sip'
import StatisticService from './services/statistic'
import SystemService from './services/system'
import UserService from './services/user'
export class Promobot {
  static getInstance(options) {
    return new Promise((resolve, _reject) => {
      const connection = new MessageChannelQWebChannel(options)
      connection.connect().then(() => resolve(new Promobot(connection)))
    })
  }
  static getEmulateInstance(options) {
    return new Promise((resolve, _reject) => {
      const connection = new MessageChannelEmulator(options)
      connection.connect().then(() => resolve(new Promobot(connection)))
    })
  }
  constructor(messageChannel) {
    this.messageChannel = messageChannel
    this.audioService = new AudioService(messageChannel)
    this.barcodeService = new BarcodeService(messageChannel)
    this.cameraService = new CameraService(messageChannel)
    this.customEventsService = new CustomService(messageChannel)
    this.dialogService = new DialogService(messageChannel)
    this.dispenserService = new DispenserService(messageChannel)
    this.documentScannerService = new DocumentScannerService(messageChannel)
    this.driveService = new DriveService(messageChannel)
    this.environmentService = new EnvironmentService(messageChannel)
    this.faceRecognizeService = new FaceRecognizeService(messageChannel)
    this.filesystemService = new FilesystemService(messageChannel)
    this.fingerprintScannerService = new FingerprintScannerService(messageChannel)
    this.interactionService = new InteractionService(messageChannel)
    this.keyboardService = new KeyboardService(messageChannel)
    this.logService = new LogService(messageChannel)
    this.mailService = new MailService(messageChannel)
    this.operatorService = new OperatorService(messageChannel)
    this.passportScannerService = new PassportScannerService(messageChannel)
    this.paymentTerminalService = new PaymentTerminalService(messageChannel)
    this.printPhotoService = new PromobotPrintPhotoService(messageChannel)
    this.printService = new PrinterService(messageChannel)
    this.pushService = new PushService(messageChannel)
    this.rfidService = new RfidService(messageChannel)
    this.rfidSecondaryService = new RfidSecondaryService(messageChannel)
    this.scriptsService = new ScriptsService(messageChannel)
    this.settingsService = new SettingsService(messageChannel)
    this.sipService = new SipService(messageChannel)
    this.statisticService = new StatisticService(messageChannel)
    this.systemService = new SystemService(messageChannel)
    this.userService = new UserService(messageChannel)
    console.info(`%cPromobot API version: ${ this.version }`, 'background: #222; color: #bada55')
  }
  
  
  getMessageChannel() {
    return this.messageChannel
  }
  get version() {
    return packageJson.version
  }
}
export default Promobot
